import React, { useState, useRef, useEffect } from 'react';

import { Window, WindowActionsBar } from "@progress/kendo-react-dialogs";

export default function WindowDialog(props) {
	
	const { title, initialHeight, minHeight, initialWidth, minWidth, render, buttons, onClose, dialogResized, className = "constituo-window-dialog", stage = "DEFAULT", contentLayout = "scroll", ...windowProps } = props;

	const windowClassName = [className, contentLayout === "grid" ? "constituo-window-grid-dialog" : ""].filter(Boolean).join(" ");
	
	const [windowStage, setWindowStage] = useState(stage);
	
	const focusRef = useRef(null);
	
	useEffect(() => {
		focusRef.current.element.focus();
	}, []);
	
	const handleStageChange = (e) => {
		setWindowStage(e.state);
	};
	
	const onResize = (e) => {
		if (dialogResized) dialogResized(e);
	};	
	
	return (
		<Window
			{...windowProps}
			role="dialog"
			ref={focusRef}
			tabIndex={0}
			className={windowClassName}
			style={{
				...props.style,
				"--constituo-dialog-min-height": typeof minHeight === "number" ? `${minHeight}px` : (minHeight || "200px"),
				"--constituo-dialog-min-width": typeof minWidth === "number" ? `${minWidth}px` : (minWidth || "200px")
			}}
			title={title}
			onClose={onClose}
			resizable={true}
			initialHeight={initialHeight}
			minHeight={minHeight}
			initialWidth={initialWidth}
			minWidth={minWidth}
			draggable={true}
			modal={true}			
			stage={windowStage}
			onStageChange={handleStageChange}
			onResize={onResize}
		>
			<div 
				tabIndex={0}
				role="region"
				aria-label="Dialog Panel"
				className="constituo-dialog-shell"
			>
				<div
					tabIndex={0}
					role="region"
					aria-label="Dialog Content Panel"
					className="constituo-dialog-content"
				>
	       			{render()}
	        	</div>
				<div
					tabIndex={0}
					role="region"
					aria-label="Dialog Button Bar"
					className="constituo-dialog-actions"
				>
					<WindowActionsBar layout="stretched">
						{buttons}
					</WindowActionsBar>
				</div>
			</div>
		</Window>		
	);
}
